<template>
  <CommonNoticeCard
    :class="b()"
  >
    <div
      slot="content"
      :class="b('content')"
    >
      {{ content }}
    </div>
    <template #actions>
      <el-button
        v-if="!isAWSUserMark && hasUpgradePermission"
        type="primary"
        :class="b('btn')"
        size="mini"
        @click.stop="toUpgrade"
      >
        {{ $t('button.Upgrade') }}
      </el-button>
    </template>
  </CommonNoticeCard>
</template>

<script>
import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import theme from '@zk/theme/lib/variables.scss';
import { mapGetters } from 'vuex';
import * as permission from 'common-module/src/config/permission';

export default {
  name: 'VideoCommentNoPermissionNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('user', ['checkAccessPermission']),
    hasUpgradePermission() {
      return this.checkAccessPermission(permission.upgrade);
    },
    isAWSUserMark() {
      return this.$store.getters.isAWSUserMark;
    },
    content() {
      return this.hasUpgradePermission ? this.$t('notice.videoCommentUpgradeNotice.adminContent') : this.$t('notice.videoCommentUpgradeNotice.normalContent');
    }
  },
  methods: {
    toUpgrade() {
      this.eventBus.$emit('global:openUpgradeDialog');
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(video-comment-no-permission-notice-card) {
  @include e(btn) {
    color: var(--font-color-5) !important;
  }
  @include e(content) {
    color: var(--font-color-1);
  }
}
</style>
<style lang="scss">
.video-comment-permission-notice-card {
  &:before {
    background-color: var(--primary-color);
  }
  .el-notification__title {
    color: var(--primary-color);
  }
}
</style>
